import React from 'react';
import {Link} from 'react-router-dom';
import _Logo from './_Logo.scss';

class Logo extends React.Component {

  render() {
    return (
      <h1 className='logo'>
        <Link to='/' className='logo-link'>
          <p className="logo-text">HUETRADE</p>
        </Link>
      </h1>
    )
  }
}

export default Logo



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/Logo.jsx